<template>
  <RunCard
    v-bind="{run}"
    @runClick="handleRunClick"
  >
    <template #actions>
      <RunActionButtonView
        v-if="canInteractWithRun || canReviewRun"
        :modelValue="run"
      />
    </template>
  </RunCard>
</template>

<script lang="ts" setup>
import RunCard from "@/components/RunCard.vue";
import useUpdateStatus from "@/composables/useUpdateStatus.ts";
import getRouteForRun from "@/lib/utils/route/getRouteForRun.ts";
import useModalStore from "@/stores/useModalStore";
import { RunForCarousel } from "@/stores/useRunCarouselStore";
import { toRefs } from "vue";
import RunActionButtonView from "./RunActionButtonView.vue";

const props = defineProps<{
  run: RunForCarousel,
}>();

const {
  openModal,
} = useModalStore();

const {
  run,
} = toRefs(props);

const {
  canInteractWithRun,
  canReviewRun,
} = useUpdateStatus(run);

function handleRunClick () {
  openModal(getRouteForRun(run.value.id));
}
</script>
